var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-grid-wrapper"
  }, [_c('div', {
    staticClass: "card-grid"
  }, [_c('div', {
    staticClass: "card-grid__inner"
  }, [_c('div', {
    staticClass: "card-grid__title"
  }, [_vm._v("\n        " + _vm._s(_vm.activePage.heading[_vm.language.code]) + "\n      ")]), _c('div', {
    staticClass: "grid"
  }, _vm._l(_vm.activePage.cards, function (card, cardIndex) {
    return _c('div', {
      key: 'card' + cardIndex,
      staticClass: "card"
    }, [card.asset ? _c('div', {
      staticClass: "card__image"
    }, [_c('img', {
      attrs: {
        "src": _vm.$store.state.assetsPath + card.asset.path,
        "alt": ""
      }
    })]) : _vm._e(), _c('div', {
      staticClass: "card__inner"
    }, [_c('div', {
      staticClass: "card__top"
    }, [_c('div', {
      staticClass: "card__sublabel"
    }, [_vm._v("\n                " + _vm._s(card.sublabel[_vm.language.code]) + "\n              ")]), _c('div', {
      staticClass: "card__price"
    }, [_vm._v("\n                " + _vm._s(card.price[_vm.language.code]) + "\n              ")])]), _c('div', {
      staticClass: "card__label"
    }, [_vm._v("\n              " + _vm._s(card.label[_vm.language.code]) + "\n            ")]), _c('div', {
      staticClass: "card__body",
      domProps: {
        "innerHTML": _vm._s(card.body[_vm.language.code])
      }
    }), card.tags.length ? _c('div', {
      staticClass: "card__tags"
    }, _vm._l(card.tags, function (tag, tagIndex) {
      return _c('div', {
        key: 'tag' + tagIndex,
        staticClass: "tag"
      }, [_vm._v("\n                " + _vm._s(tag) + "\n              ")]);
    }), 0) : _vm._e(), _c('div', {
      staticClass: "card__qrcode"
    }, [card.qrCode[_vm.language.code] ? _c('div', {
      staticClass: "card__qr"
    }, [_c('qrcode-vue', {
      attrs: {
        "render-as": "canvas",
        "background": "#fff",
        "value": card.qrCode[_vm.language.code]
      }
    })], 1) : _vm._e()])])]);
  }), 0)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }